/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import CheckoutConfirmation from "@/src/containers/HigherOrderContainers/CheckoutConfirmation";

const PaidPage = () => {
  return (
    <>
      <Helmet>
        <title>Zahlung erfolgreich | Legalbird</title>
      </Helmet>
      <CheckoutConfirmation />
    </>
  );
};

export default PaidPage;
